import request from '@/api/request'

// Get VIN configuration
export function vinTenantIdConfigurationGetVinConfig() {
  return request({
    url: '/configuration/getVinConfig',
    method: 'get'
  })
}

// Update VIN configuration
export function vinTenantIdConfigurationUpdateVinConfig(data) {
  return request({
    url: '/configuration/updateVinConfig',
    method: 'post',
    data: data
  })
}

